import { Component, HostListener, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { UserPageTrackingService } from '../../../../shared/signalR/userPageTrackingService';
import { AuthService } from '../../../../auth/auth.service';

@Component({
  selector: 'app-page-user-list',
  templateUrl: './page-user-list.component.html',
  styleUrls: ['./page-user-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PageUserListComponent implements OnInit, OnDestroy {
  private routerSubscription: Subscription;
  public userName = '';

  constructor(
    private authService: AuthService,
    public pageUserService: UserPageTrackingService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const currentUser = this.authService.currentUser;
    if (!currentUser) {
      return;
    }
    this.userName = `${currentUser.firstName} ${currentUser.lastName}`
    this.pageUserService.logUrlChange(this.userName);

    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.pageUserService.logUrlChange(this.userName);
      }
    });
  }

  ngOnDestroy() {
    if (this.userName) {
      this.pageUserService.leavePage(this.userName);
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  showName(item: any) {
    item.showFullName = true;
  }

  hideName(item: any) {
    item.showFullName = false;
  }

  addDotsToString(input: string): string {
    return input.split('').join('.');
  }
}


// WEBPACK FOOTER //
// ./src/app/core/components/header/page-user-list/page-user-list.component.ts